import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InspectionTestsApiDto } from '../dto/inspection-tests.dto';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInspectionTestsService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }
  protected urlRoute = `${API_BASE_URL}/inspection/tests`;

  allTypes(): Observable<{ id: number; title: string }[]> {
    return this.http.get<{ id: number; title: string }[]>(
      `${this.urlRoute}/types`
    );
  }

  finishTests(
    inspectionId: number,
    body: InspectionTestsApiDto['finish']['body']['data']
  ): Observable<any> {
    return this.http.post(`${this.urlRoute}/finish/${inspectionId}`, {
      data: body,
    });
  }
}
